package com.essntl.features.request.data.supabase

import com.essntl.features.request.domain.model.RequestModel
import kotlinx.serialization.json.JsonArray
import kotlinx.serialization.json.JsonElement
import kotlinx.serialization.json.JsonPrimitive

internal fun RequestModel.toRequestMap(): Map<String, JsonElement> {
    val requestMap = mutableMapOf<String, JsonElement>()

    if (startDate.isNotEmpty()) {
        requestMap["from_date"] = JsonPrimitive(startDate)
    }

    if (endDate.isNotEmpty()) {
        requestMap["to_date"] = JsonPrimitive(endDate)
    }

    if (!areas.isNullOrEmpty()) {
        requestMap["areas"] = JsonArray(areas!!.map { JsonPrimitive(it) })
    }

    if (!proposalId.isNullOrEmpty()) {
        requestMap["proposal_id"] = JsonPrimitive(proposalId!!)
    }

    if (travelAgent != null) {
        requestMap["travel_agent"] = JsonPrimitive(travelAgent?.id)
    }

    if (title != null) {
        requestMap["title"] = JsonPrimitive(title!!)
    }

    if (!extras.isNullOrEmpty()) {
        requestMap["extras"] = JsonPrimitive(extras!!)
    }

    if (!ownerId.isNullOrEmpty()) {
        requestMap["owner_id"] = JsonPrimitive(ownerId!!)
    }

    if (status != null) {
        requestMap["status"] = JsonPrimitive(status!!.toDto())
    }

    clients?.let { clients ->
        requestMap["clients"] = JsonArray(clients.map { JsonPrimitive(it) })
    }

    if (guestCount != -1) {
        requestMap["guest_count"] = JsonPrimitive(guestCount)
    }

    guestDetails?.let {
        requestMap["guest_details"] = JsonPrimitive(it)
    }

    return requestMap
}
